export default {
  tipsOne:
    '1. Conservaremos los bienes para usted sin cargo durante 90 días. Si no envía el paquete o no toma ninguna acción después de 90 días, se considerará que ha renunciado a los bienes y los destruiremos uniformemente.',
  tipsTwo:
    '2. Los bienes han sido almacenados. Puede ingresar a mi almacén en cualquier momento y enviarlos a su dirección de entrega en el extranjero.',
  orderDetail: 'Detalle del pedido',
  orderNo: 'Número de pedido',
  orderConsult: 'Consulta de pedido',
  consult: 'Consulta',
  orderConsultTips:
    'El agente de compra solo puede manejar negocios relacionados con este pedido. Para consultas de otros negocios, comuníquese con',
  enquiryReplyMsg:
    'Ingrese aquí, le responderemos dentro de las 24 horas. (Nota: A veces utilizaremos software de traducción para responder, lo que puede no transmitir el significado con precisión. Esperamos su comprensión).',
  stepListEnum: {
    '-1': 'Seleccionar productos',
    0: 'Enviar paquete',
    6: 'Pagar el flete',
    9: 'Enviar paquete',
    20: 'Confirmar recepción'
  }
};